/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Partner_Detail_Meta_AccruingInputs */



/**
* | output |
* | --- |
* | "{amount} accumulating" |
*
* @param {Partner_Detail_Meta_AccruingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_meta_accruing = /** @type {((inputs: Partner_Detail_Meta_AccruingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_Meta_AccruingInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.amount} aufgelaufen`)
	return /** @type {LocalizedString} */ (`${i?.amount} accumulating`)
});